module.exports = new __parcel__URL__("tabs_ko.22207a74.webp").toString();